import * as IonIcons5 from "react-icons/io5";
import * as Remix from "react-icons/ri";
export default {
    IonIcons5: IonIcons5,
    Remix: Remix,
};
//# sourceMappingURL=index.js.map